import RouteName from '@/models/enums/RouteName'

export default [
  {
    path: '/promocodes',
    name: RouteName.Promocodes,
    component: () => import('@/pages/Promocodes/Promocodes'),
    meta: {
      breadcrumb: {
        label: 'Промокоды',
        parent: RouteName.Directory,
      },
    },
  },
  {
    path: '/promocodes/create',
    name: 'Новый промокод',
    component: () => import('@/pages/Promocodes/PromocodesCreate'),
    meta: {
      breadcrumb: {
        label: 'Новый промокод',
        parent: RouteName.Promocodes,
      },
    },
  },
  {
    path: '/promocodes/:id',
    name: 'Промокод',
    component: () => import('@/pages/Promocodes/PromocodesSingle'),
    meta: {
      breadcrumb: {
        label: 'Редактирование промокода',
        parent: RouteName.Promocodes,
      },
    },
  },
]
